import { Link } from "react-router-dom";
import { Typography as T } from "@mui/material";
import { adminLoginFullPath, employeeLoginFullPath } from "../routes/paths";

export const ChooseLogin = () => {
  return (
    <div className="flex flex-col items-center justify-center w-100 h-screen">
      <div className="w-50">
        <>
          <T variant="lgMed">
            Hey. You're not logged in. Please choose one of the following:
          </T>
          <div className="mt-16">
            <T>
              If you are an admin, login in{" "}
              <Link to={adminLoginFullPath}>here.</Link>
            </T>
            <T>
              If you are an employee, login in{" "}
              <Link to={employeeLoginFullPath}>here.</Link>
            </T>
          </div>
        </>
      </div>
    </div>
  );
};

export default ChooseLogin;
